import React from 'react';

import { Box, Flex, Typography, TruncateMarkup } from 'shared';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { LinkPreviewSmallPropTypes } from 'features/chat/config/types/LinkPreview';

export const ChatMessageLinkPreviewSmall = ({
  title,
  siteName,
  url,
}: LinkPreviewSmallPropTypes) => {
  const textColor = 'black';

  return (
    <a href={url} target="_blank" rel="noreferrer">
      <Flex>
        <Box w="3px" bg="var(--bgCompAccent)" />
        <Spacer size="sm" />
        <Flex w="100%">
          <Flex flexDirection="column" gap={0.5}>
            <Typography type="meta" fontWeight="medium" color="blue">
              {siteName}
            </Typography>
            <TruncateMarkup lines={2} ellipsis={<span>...</span>}>
              <Typography type="meta" color={textColor}>
                🔗 {title}
              </Typography>
            </TruncateMarkup>
          </Flex>
        </Flex>
      </Flex>
    </a>
  );
};
